import React from "react";
export default function Selezione({arr}){

    function handleSelect (e){
        try {   
            document.querySelector(`#${e.target.value}`).scrollIntoView({block:"start"});
        } catch (error) {
            return null;
        }
        
    }

    return (

        <div style={{textAlign:"center"}}>
                
            <select name="" id="dropDown" onChange={event=>handleSelect(event)}>
                <option value="niente">Seleziona</option>
                {arr.map((elem)=><option key={elem} value={elem.split(" ").join("")}>{elem}</option>)}
            </select>
        </div>
        
    )
}